import * as Yup from "yup";

export const LoginFormSchema = Yup.object().shape({
  username: Yup.string()
    .email("Username is not valid email")
    .required("Username is required"),
  password: Yup.string().required("Password is required"),
});
